import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import baseURL from '../url';
import './ProductsPageCatalogo.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import moneda from '../moneda';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import busquedaImage from '../../images/busqueda.svg'
import CuponesModal from '../CuponesModal/CuponesModal';
// import { ftMostrarPrecioNormalMayoreo } from './ProductosPageHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCartShopping } from '@fortawesome/free-solid-svg-icons';
import ubicacion from "../../images/ubicacion.png";
import envios from "../../images/envio.png";
import { ftMostrarPrecioNormalMayoreo } from '../ProductsPage/ProductosPageHelper';
import ListaCategoria from '../ListaCategoria/ListaCategoria';

// ✅ Función para detectar el tipo de imagen y ajustar el object-fit
const getImageFitStyle = (imageUrl) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const { width, height } = img;
            const aspectRatio = width / height;
            
            // ✅ Imágenes verticales (1080×1920) - tipo TikTok
            if (aspectRatio <= 0.7) {
                resolve('cover');
            }
            // ✅ Imágenes cuadradas o cercanas al cuadrado (1080×1080)
            else if (aspectRatio >= 0.8 && aspectRatio <= 1.2) {
                resolve('contain');
            }
            // ✅ Imágenes horizontales
            else {
                resolve('contain');
            }
        };
        img.onerror = () => {
            resolve('contain'); // Fallback por defecto
        };
        img.src = imageUrl;
    });
};

// ✅ Función para determinar si un producto tiene imágenes verticales
const hasVerticalImages = (producto, imageFitStyles) => {
    const images = [producto.imagen1, producto.imagen2, producto.imagen3, producto.imagen4].filter(Boolean);
    const hasVertical = images.some(imageUrl => imageFitStyles[imageUrl] === 'cover');
    
    return hasVertical;
};

export default function ProductsPageCatalogo({ setItemsProps, categoriasFiltroProps, tallasFiltroProps, setProductosProps, cuponesProps = [], cuponAplicado, setCuponAplicado, hasWave = false }) {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const idCategoriaFiltroInicial = params.get('idCategoria');
    const categoriasFiltro = categoriasFiltroProps === '' ? (idCategoriaFiltroInicial || null) : categoriasFiltroProps?.value;
    const swiperRef = useRef(null);
    const [productos, setProductos] = useState([]);
    const [productosFiltrados, setProductosFiltrados] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [openEnviosModal, setOpenEnviosModal] = useState(false);
    const [openCuponesModal, setOpenCuponesModal] = useState(false);
    const [verDetalles, setVerDetalles] = useState(false);
    const [pauseAutoplay, setPauseAutoplay] = useState(false);
    const [imageFitStyles, setImageFitStyles] = useState({}); // ✅ Estado para los estilos de las imágenes
    const [imageLoaded, setImageLoaded] = useState({}); // ✅ Estado de carga por imagen

    // ✅ Función para cargar los estilos de las imágenes
    const loadImageStyles = async (productos) => {
        const styles = {};
        for (const producto of productos) {
            const images = [producto.imagen1, producto.imagen2, producto.imagen3, producto.imagen4].filter(Boolean);
            for (const imageUrl of images) {
                if (imageUrl && !styles[imageUrl]) {
                    const fitStyle = await getImageFitStyle(imageUrl);
                    styles[imageUrl] = fitStyle;
                }
            }
        }
        setImageFitStyles(styles);
    };

    useEffect(() => {
        if (categoriasFiltro === null) {
            return; // Salimos del useEffect
        }
        cargarProductosPorCategoria();
    }, [categoriasFiltro]);

    useEffect(() => {

        if ((categoriasFiltro === '' || categoriasFiltro === undefined) && (tallasFiltroProps === "" || tallasFiltroProps === undefined)) {
            setProductosFiltrados(productos);
            return; // Salimos del useEffect
        }
        const productosFiltrados = productos.filter(producto => {

            // Si el producto no tiene idCategoria, lo incluimos siempre
            if (producto.idCategoria === undefined || producto.idCategoria === null) {
                return true;
            }
            // Filtro por categorías
            const coincideCategoria =
                categoriasFiltro === '' || // Si no hay categorías seleccionadas, no se filtra
                categoriasFiltro === producto.idCategoria;

            // Filtro por talla (stock mayor a 0)
            const coincideTalla =
                !tallasFiltroProps || // Si no hay talla seleccionada, no se filtra
                (tallasFiltroProps === "Ch" && producto.stockItem1 > 0) ||
                (tallasFiltroProps === "M" && producto.stockItem2 > 0) ||
                (tallasFiltroProps === "G" && producto.stockItem3 > 0) ||
                (tallasFiltroProps === "Xg" && producto.stockItem4 > 0) ||
                (tallasFiltroProps === "Xxg" && producto.stockItem5 > 0);

            // El producto debe coincidir con ambos filtros (categorías y talla)
            return coincideCategoria && coincideTalla;
        });
        setProductosFiltrados(productosFiltrados);
        if (swiperRef.current) {
            //Aparece como destruido cuando no hay productos en una categoría, por eso se agrega la condición
            // Si el swiper ha sido destruido, no intentamos acceder a él
            if (swiperRef.current.destroyed) {
                return;
            }
            swiperRef.current.slideTo(0);
        }
    }, [categoriasFiltroProps, tallasFiltroProps]);


    const cargarProductosPorCategoria = () => {
        fetch(`${baseURL}/api/productos/catalogo?idCategoria=${categoriasFiltro}`)
            .then(response => response.json())
            .then(async (data) => {
                setProductosProps(data.productos || []);
                setProductos(data.productos || []);
                setProductosFiltrados(data.productos || []);
                setLoading(false);
                // ✅ Cargar los estilos de las imágenes después de obtener los productos
                await loadImageStyles(data.productos);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const markImageLoaded = (imageUrl) => {
        if (!imageUrl) return;
        setImageLoaded((prev) => ({ ...prev, [imageUrl]: true }));
    };

    const addToCart = (producto, talla) => {
        if (!producto) return;

        const isAccessory = producto.esAccesorio === 'si';
        const tallaInfo = isAccessory
            ? { talla: talla || producto.item1, stock: parseInt(producto.stockItem1) || 0 }
            : { talla, stock: parseInt(producto[`stockItem${['Ch','M','G','Xg','Xxg'].indexOf(talla) + 1}`]) || parseInt(producto.stock) || 0 };

        if (tallaInfo.stock <= 0) {
            toast.error('Sin stock disponible para esta talla', { autoClose: 800 });
            return;
        }

        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        const itemInCart = cart.findIndex(item => item.idProducto === producto.idProducto && item.item === tallaInfo.talla);
        if (itemInCart !== -1) {
            cart[itemInCart].cantidad += 1;
        } else {
            cart.push({ ...producto, talla: tallaInfo.talla, item: tallaInfo.talla, cantidad: 1 });
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        const itemsCount = cart.reduce((acc, item) => acc + item.cantidad, 0);
        setItemsProps(itemsCount);
        toast.success(`Añadido: ${producto.titulo} - Talla: ${tallaInfo.talla || 'Sin talla'}`, { autoClose: 400 });
    };


    return (
        <div className="ProductsContainer">
            {/* Modal de ubicación */}
            <Modal
                isOpen={openModal}
                onRequestClose={() => setOpenModal(false)}
                className="modalLocation"
                overlayClassName={'overlayLocation'}
            >
                <div className='bodyModalLocation'>
                    <h2>Ubicación tienda</h2>
                    <button onClick={() => setOpenModal(false)}>X</button>
                </div>
                <img src={ubicacion} alt='Ubicación' className='shopLocation' />
            </Modal>
            {/* Modal de Envíos */}
            <Modal
                isOpen={openEnviosModal}
                onRequestClose={() => setOpenEnviosModal(false)}
                className="modalLocation"
                overlayClassName={'overlayLocation'}
            >
                <div className='bodyModalLocation'>
                    <h2>Envíos (pendiente imagen)</h2>
                    <button onClick={() => setOpenEnviosModal(false)}>X</button>
                </div>
                <img src={envios} alt='Envios' className='shopLocation' />
            </Modal>
            {/* Modal de Cupones */}
            <CuponesModal openModal={openCuponesModal} setOpenModal={setOpenCuponesModal} cuponesProps={cuponesProps} setCuponAplicado={setCuponAplicado} />

            {loading ? (
                <p>Cargando productos...</p>
            ) : (
                (productosFiltrados.length > 0) ?
                    <>
                        <Swiper
                            direction="vertical"
                            pagination={{ clickable: true }}
                            mousewheel={true}
                            className="productosSwiper"
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper; // Asignar la instancia de Swiper a la referencia
                            }}
                            onSlideChange={() => {
                                setPauseAutoplay(false); // Reactiva el autoplay de imágenes al cambiar de producto
                            }}
                        >
                            {productosFiltrados.map((producto, index) => (
                                <SwiperSlide key={`${producto.idProducto}-${index}`} className="productoSlide">
                                    {
                                        <>
                                            <Swiper
                                                slidesPerView={1}
                                                pagination={{ clickable: true }}
                                                loop
                                                modules={[Autoplay]}
                                                className={`swiperHorizontal ${hasVerticalImages(producto, imageFitStyles) ? 'has-vertical-images' : 'has-square-images'} ${hasWave ? 'has-wave' : ''}`}
                                                autoplay={!pauseAutoplay ? { delay: 4000, disableOnInteraction: false } : false}
                                                onSwiper={(swiper) => {
                                                    // Swiper inicializado
                                                }}
                                                onTouchStart={() => {
                                                    setPauseAutoplay(true);
                                                }}
                                                onTouchEnd={() => {
                                                    setPauseAutoplay(false);
                                                }}
                                                onClick={() => setVerDetalles(false)} // ✅ OCULTAR TALLAS AL HACER CLIC
                                            >
                                                {[producto.imagen1, producto.imagen2, producto.imagen3, producto.imagen4]
                                                    .filter(Boolean)
                                                    .map((imgUrl, idx) => (
                                                        <SwiperSlide key={`${producto.idProducto}-img-${idx}`}>
                                                            <div className="imgWithSkeleton">
                                                                {!imageLoaded[imgUrl] && (
                                                                    <div className="imgSkeleton">
                                                                        <div className="iconTrack">
                                                                            <span>👕</span>
                                                                            <span>👖</span>
                                                                            <span>🧥</span>
                                                                            <span>👗</span>
                                                                        </div>
                                                                        <div className="shimmer" />
                                                                    </div>
                                                                )}
                                                                <img
                                                                    src={imgUrl}
                                                                    alt={producto.titulo}
                                                                    onClick={() => setVerDetalles(false)}
                                                                    style={{
                                                                        objectFit: imageFitStyles[imgUrl] || 'contain'
                                                                    }}
                                                                    onLoad={() => markImageLoaded(imgUrl)}
                                                                    onError={() => markImageLoaded(imgUrl)}
                                                                />
                                                            </div>
                                                        </SwiperSlide>
                                                    ))}
                                            </Swiper>

                                            <div className='verDetallesContainer' id="tour-detalles" >
                                                <FontAwesomeIcon icon={verDetalles ? faEyeSlash : faEye} size='lg' className='btnShopShakeGlow' onClick={() => setVerDetalles(verDetalles => !verDetalles)} style={{ cursor: 'pointer' }} />
                                                <p style={{ marginLeft: '5px', cursor: 'pointer' }} onClick={() => setVerDetalles(verDetalles => !verDetalles)}> <strong>{
                                                    `${!verDetalles ? 'Ver tallas' : 'Ocultar'}`
                                                }</strong></p>

                                            </div>
                                            {/* 🛠 Contenedor para el título, descripción, precio y tallas */}
                                            <div className="productoInfoContainer" style={{ display: verDetalles ? 'flex' : 'none' }}>
                                                <div className="productoInfo">
                                                    <h2>{producto.titulo}</h2>
                                                    <p>{producto.descripcion}</p>
                                                </div>

                                                {/* ✅ Sección de precios reorganizada */}
                                                {(producto.precioAnterior && 
                                                  producto.precioAnterior > 0 && 
                                                  producto.precioAnterior > ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto })) ? (
                                                    <div className="preciosContainer">
                                                        <div className="precioAnterior">
                                                            {moneda} {parseInt(producto.precioAnterior).toLocaleString()}
                                                        </div>
                                                        <div className="productoPrecio">
                                                            {moneda} {ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto }).toLocaleString()}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="preciosContainer">
                                                        <div className="productoPrecio">
                                                            {moneda} {ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto }).toLocaleString()}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* ✅ Tallas reorganizadas */}
                                                {producto.esAccesorio == 'si' ?
                                                    (
                                                        <div className="tallas">
                                                            <button onClick={() => addToCart(producto, producto.item1)}
                                                                disabled={producto.item1 && producto.stockItem1 <= 0}
                                                                className={`${producto.stockItem1 <= 0 && 'disabledBtnAddCart'}`}
                                                            >
                                                                <FontAwesomeIcon icon={faCartShopping} size='lg' style={{ color: "black" }} />
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="tallas">
                                                            {Array.from({ length: 5 }, (_, i) => {
                                                                const talla = producto[`item${i + 1}`];
                                                                const stock = producto[`stockItem${i + 1}`];
                                                                return { talla, stock };
                                                            })
                                                                .map((item, index) => (
                                                                    <button key={index} onClick={() => addToCart(producto, item.talla)}
                                                                        disabled={item.talla && item.stock <= 0}
                                                                        className={`${item.stock <= 0 && 'disabledBtnAddCart'}`}
                                                                    >
                                                                        {item.talla}
                                                                    </button>
                                                                ))}
                                                        </div>
                                                    )}
                                            </div>
                                        </>
                                    }

                                </SwiperSlide>
                            ))}
                            
                            {/* Slide adicional con categorías al final */}
                            <SwiperSlide className="categoriasSlide">
                                <ListaCategoria 
                                    isCompact={true} 
                                    currentCategoryId={categoriasFiltro}
                                />
                            </SwiperSlide>
                        </Swiper>
                    </>
                    :
                    <div className='noProductsContainer'>
                        <img src={busquedaImage} alt='Busqueda' />
                        <p>No hay resultados con la búsqueda solicitada</p>
                    </div>
            )
            }
        </div >
    );
}
